import { component, demoFile } from 'system/demo';
import { t } from 'util/stdtypes';

import { REPLACE_ZDF_DropDownSelector } from '../channel-dropdown';

demoFile('open-modules/zdf/component/channels/channel-dropdown');

const options = [
    { key: '1', label: t('!One') },
    { key: '2', label: t('!Two') },
];

function REPLACEZDFDropDownSelectorDemo(props) {
    return <REPLACE_ZDF_DropDownSelector {...props} />;
}

component('REPLACE_ZDF_DropDownSelector', REPLACEZDFDropDownSelectorDemo, {
    args: { testID: 'dd', options, value: '1', onChange: () => {} },
});
